import { createContext, type ReactNode, useContext } from 'react';

import type { VariantProps } from 'class-variance-authority';

import type { stackVariants } from '@/lib/shadcn/components/ui/stack/stack';

export interface BaseDrawerView {
  id: string;
  title: ReactNode;
  description?: string;
  children: ReactNode;
  primaryAction?: ReactNode;
  secondaryAction?: ReactNode;
  footerContent?: ReactNode;
  showButtonClose?: boolean;
  drawerFooterClassName?: string;
  handleOnly?: boolean;
  headerClassName?: string;
  contentGap?: VariantProps<typeof stackVariants>['gap'];
  className?: string;
  overlayClassName?: string;
  onClose?: () => void;
  onOpenChange?: (open: boolean) => void;
  onCloseAutoFocus?: (event: Event) => void;
}

export interface BaseDrawerStackContextValue {
  registerView: (view: BaseDrawerView) => void;
  unregisterView: (id: string) => void;
}

export const BaseDrawerStackContext = createContext<BaseDrawerStackContextValue | null>(
  null,
);

export function useBaseDrawerStack() {
  return useContext(BaseDrawerStackContext);
}
